export { addGlobalMessage, addCustomGlobalMessage } from './molecules/globalCommunicationWrapper'
